module.exports = __webpack_public_path__ + "07fa4774cb732d3be562456712cbd315.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Lato-LightItalic.woff2
// module id = 695
// module chunks = 0